import React, { Component, Fragment } from "react";
import gql from "graphql-tag";
import { Query, Mutation } from "react-apollo";
import AddIcon from "@material-ui/icons/Add";
import CopyIcon from '@material-ui/icons/FileCopy';
import DeleteIcon from '@material-ui/icons/Delete';
import UploadFileDialog from "./addFileModal";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import { withNotification } from "../notification/context";
import {
  withStyles,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Fab,
  Tooltip,
} from '@material-ui/core';

const styles = theme => ({
  root: {
    marginTop: 48,
    marginLeft : 32,
    marginRight :32,
    marginBottom: 32,
    position : 'relative',
  },
  table: {
  },
  fab : {
    position  : 'absolute',
    top       : 0,
    right     : 0,
    transform : `translateX(${50}%) translateY(${-50}%)`,
  }
});

const GET_FILES = gql`
  {
    allFiles {
      id
      filename
      mimetype
      encoding
      Location
      ETag
      Bucket
      Key
      name
    }
  }
`;

const UPLOAD_FILE = gql`
  mutation singleUpload($file: Upload!, $name: String!) {
    singleUpload(file: $file, name: $name) {
      id
      filename
      mimetype
      encoding
      Location
      ETag
      Bucket
      Key
      name
    }
  }
`;

const DELETE_FILE = gql`
  mutation($id:ID!, $key: String!){
    deleteFile(id:$id, key: $key){
      name
      filename
    }
  }
`;

class FilesDashboard extends Component {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({
      open: true
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  copyClipboard(target){
    target.select();
    document.execCommand('copy');
    // This is just personal preference.
    // I prefer to not show the the whole text area selected.
    alert(target);
  };

  render() {
    const { classes, openNotification } = this.props;

    return (
      <Mutation 
        mutation={DELETE_FILE}
        refetchQueries={() => [{ query: GET_FILES }]}
        onCompleted={() => openNotification('Archivo eliminado!')}
      >
          {deleteFile => (
            <Paper className={classes.root}>
              <Query query={GET_FILES}>
                {({ loading, error, data }) => {
                  if (loading) return "Loading...";
                  if (error) return `Error! ${error.message}`;
                  const { allFiles } = data;
                  return (
                    <Fragment>
                      <Fab
                        className={classes.fab}
                        color="primary"
                        onClick={this.handleOpen}
                      >
                        <AddIcon />
                      </Fab>
                      <Table className={classes.table} size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Nombre para mostrar</TableCell>
                            <TableCell>Nombre del archivo</TableCell>
                            <TableCell>Tipo MIME</TableCell>
                            <TableCell>Acciones</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {allFiles.map(row => {
                            return (
                              <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                  {row.name}
                                </TableCell>
                                <TableCell>{row.filename}</TableCell>
                                <TableCell>{row.mimetype}</TableCell>
                                <TableCell>
                                  <CopyToClipboard
                                      text={row.Location}
                                      onCopy={() => openNotification('¡Copiado al portapapeles!')}
                                  >
                                    <IconButton aria-label="copy">
                                      <Tooltip title="Copiar URL" placement="left" >
                                        <CopyIcon/>
                                      </Tooltip>
                                    </IconButton>
                                  </CopyToClipboard>
                                  <IconButton aria-label="file-delete">
                                      <Tooltip title="Eliminar" placement="left" >
                                        <DeleteIcon onClick={() => deleteFile({variables : {id: row.id, key: row.Key}})}/>
                                      </Tooltip>
                                    </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                      <Mutation
                        mutation={UPLOAD_FILE}
                        update={(cache, { data: { singleUpload } }) => {
                          const { allFiles } = cache.readQuery({ query: GET_FILES });
                          cache.writeQuery({
                            query: GET_FILES,
                            data: { allFiles: allFiles.concat([singleUpload]) }
                          });
                        }}
                      >
                        {(uploadFile, response) => {
                          return (
                            <UploadFileDialog
                              onSubmit={uploadFile}
                              onClose={this.handleClose}
                              opened={this.state.open}
                              {...response}
                            />
                          );
                        }}
                      </Mutation>
                    </Fragment>
                  );
                }}
              </Query>
            </Paper>
          )}
      </Mutation>
    );
  }
}

export default withNotification(withStyles(styles)(FilesDashboard));



// WEBPACK FOOTER //
// ./src/components/files/index.js